<template>
  <nav class="fixed top-0 left-0 right-0 z-50 border-b border-gray-200 dark:border-white/[0.06] bg-white/80 dark:bg-dark/80 backdrop-blur-xl transition-colors duration-300">
    <div class="container mx-auto px-4">
      <div class="flex h-16 items-center justify-between">
        <router-link to="/" class="flex items-center" @click="closeMenus">
          <img src="/ciobai_logo_long.png" alt="Ciobai Logo" class="h-5 sm:h-6 dark:brightness-0 dark:invert" />
        </router-link>

        <div class="hidden lg:flex items-center gap-8">
          <router-link to="/" class="text-[13px] font-medium text-gray-500 dark:text-gray-500 hover:text-gray-900 dark:hover:text-white transition-colors" @click="closeMenus">
            {{ t('nav.home') }}
          </router-link>
          <router-link to="/website" class="text-[13px] font-medium text-gray-500 dark:text-gray-500 hover:text-gray-900 dark:hover:text-white transition-colors" @click="closeMenus">
            {{ t('solutions.links.websites') }}
          </router-link>
          <router-link to="/chatbot" class="text-[13px] font-medium text-gray-500 dark:text-gray-500 hover:text-gray-900 dark:hover:text-white transition-colors" @click="closeMenus">
            {{ t('solutions.links.chatbots') }}
          </router-link>
          <div class="relative">
            <button
              @click="toggleAutomations"
              class="text-[13px] font-medium text-gray-500 dark:text-gray-500 hover:text-gray-900 dark:hover:text-white transition-colors flex items-center"
            >
              Automazioni AI
              <ChevronDown class="h-3.5 w-3.5 ml-1 transition-transform" :class="{ 'rotate-180': isAutomationsOpen }" />
            </button>
            <div
              v-if="isAutomationsOpen"
              class="absolute left-0 mt-3 w-60 rounded-xl bg-white dark:bg-dark-50 border border-gray-200 dark:border-white/[0.06] shadow-xl dark:shadow-2xl dark:shadow-black/40 z-[100]"
            >
              <div class="py-2">
                <router-link
                  v-for="item in automationsLinks"
                  :key="item.href"
                  :to="item.href"
                  class="block px-4 py-2.5 text-[13px] text-gray-500 hover:text-gray-900 dark:hover:text-white hover:bg-gray-50 dark:hover:bg-white/[0.04] transition-colors"
                  @click="closeMenus"
                >
                  {{ item.text }}
                </router-link>
              </div>
            </div>
          </div>

          <router-link to="/portfolio" class="text-[13px] font-medium text-gray-500 dark:text-gray-500 hover:text-gray-900 dark:hover:text-white transition-colors" @click="closeMenus">
            {{ t('nav.portfolio') }}
          </router-link>
          <router-link to="/chi-siamo" class="text-[13px] font-medium text-gray-500 dark:text-gray-500 hover:text-gray-900 dark:hover:text-white transition-colors" @click="closeMenus">
            {{ t('nav.aboutUs') }}
          </router-link>

          <router-link to="/contact" class="text-[13px] font-medium text-gray-500 dark:text-gray-500 hover:text-gray-900 dark:hover:text-white transition-colors">
            {{ t('nav.contact') }}
          </router-link>
        </div>

        <div class="hidden lg:flex items-center gap-3">
          <button @click="toggle" class="p-2 rounded-lg text-gray-400 hover:text-gray-900 dark:hover:text-white hover:bg-gray-100 dark:hover:bg-white/[0.06] transition-colors">
            <Moon v-if="!isDark" class="h-4 w-4" />
            <Sun v-else class="h-4 w-4" />
          </button>
          <LanguageSwitcher @language-open="closeAutomations" />
          <router-link to="/contact" class="inline-flex items-center h-9 px-5 bg-gray-900 dark:bg-white text-white dark:text-dark text-[13px] font-semibold rounded-lg hover:bg-gray-800 dark:hover:bg-gray-100 transition-colors">
            {{ t('nav.getPrototype') }}
          </router-link>
        </div>

        <div class="flex lg:hidden items-center gap-2">
          <button @click="toggle" class="p-2 rounded-lg text-gray-400 hover:text-gray-900 dark:hover:text-white transition-colors">
            <Moon v-if="!isDark" class="h-4 w-4" />
            <Sun v-else class="h-4 w-4" />
          </button>
          <button 
            @click="isMobileMenuOpen = !isMobileMenuOpen"
            class="p-2 text-gray-400 hover:text-gray-900 dark:hover:text-white"
          >
            <Menu v-if="!isMobileMenuOpen" class="h-5 w-5" />
            <X v-else class="h-5 w-5" />
          </button>
        </div>
      </div>

      <Transition
        enter-active-class="transition duration-200 ease-out"
        enter-from-class="opacity-0 -translate-y-2"
        enter-to-class="opacity-100 translate-y-0"
        leave-active-class="transition duration-150 ease-in"
        leave-from-class="opacity-100 translate-y-0"
        leave-to-class="opacity-0 -translate-y-2"
      >
        <div v-if="isMobileMenuOpen" class="lg:hidden py-6 border-t border-gray-200 dark:border-white/[0.06]">
          <div class="flex flex-col gap-1">
            <router-link to="/" class="px-3 py-2.5 text-[15px] text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white transition-colors rounded-lg hover:bg-gray-50 dark:hover:bg-white/[0.04]" @click="closeMenus">
              {{ t('nav.home') }}
            </router-link>

            <router-link to="/website" class="px-3 py-2.5 text-[15px] text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white transition-colors rounded-lg hover:bg-gray-50 dark:hover:bg-white/[0.04]" @click="closeMenus">
              {{ t('solutions.links.websites') }}
            </router-link>

            <router-link to="/chatbot" class="px-3 py-2.5 text-[15px] text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white transition-colors rounded-lg hover:bg-gray-50 dark:hover:bg-white/[0.04]" @click="closeMenus">
              {{ t('solutions.links.chatbots') }}
            </router-link>
            <button
              @click="toggleAutomations"
              class="px-3 py-2.5 text-[15px] text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white flex items-center rounded-lg hover:bg-gray-50 dark:hover:bg-white/[0.04] w-full text-left"
            >
              Automazioni AI
              <ChevronDown class="h-4 w-4 ml-1 transition-transform" :class="{ 'rotate-180': isAutomationsOpen }" />
            </button>
            <div v-if="isAutomationsOpen" class="pl-6 flex flex-col gap-1">
              <router-link v-for="item in automationsLinks"
                 :key="item.href"
                 :to="item.href"
                 class="px-3 py-2 text-sm text-gray-500 hover:text-gray-900 dark:hover:text-white transition-colors rounded-lg"
                 @click="closeMenus"
              >
                {{ item.text }}
              </router-link>
            </div>

            <router-link to="/portfolio" class="px-3 py-2.5 text-[15px] text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white transition-colors rounded-lg hover:bg-gray-50 dark:hover:bg-white/[0.04]" @click="closeMenus">
              {{ t('nav.portfolio') }}
            </router-link>
            <router-link to="/chi-siamo" class="px-3 py-2.5 text-[15px] text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white transition-colors rounded-lg hover:bg-gray-50 dark:hover:bg-white/[0.04]" @click="closeMenus">
              {{ t('nav.aboutUs') }}
            </router-link>

            <router-link to="/contact" class="px-3 py-2.5 text-[15px] text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white transition-colors rounded-lg hover:bg-gray-50 dark:hover:bg-white/[0.04]" @click="closeMenus">
              {{ t('nav.contact') }}
            </router-link>

            <div class="px-3 py-2">
              <LanguageSwitcher @language-open="closeAutomations" />
            </div>

            <div class="pt-2 px-3">
              <router-link to="/contact" class="flex items-center justify-center h-11 bg-gray-900 dark:bg-white text-white dark:text-dark text-[15px] font-semibold rounded-lg hover:bg-gray-800 dark:hover:bg-gray-100 transition-colors" @click="closeMenus">
                {{ t('nav.getPrototype') }}
              </router-link>
            </div>
          </div>
        </div>
      </Transition>
    </div>
  </nav>
</template>

<script setup>
import { ref, computed } from 'vue'
import { Menu, X, ChevronDown, Sun, Moon } from 'lucide-vue-next'
import LanguageSwitcher from './LanguageSwitcher.vue'
import { useI18n } from 'vue-i18n'
import { useTheme } from '../composables/useTheme'

const { t } = useI18n()
const { isDark, toggle } = useTheme()
const isMobileMenuOpen = ref(false)
const isAutomationsOpen = ref(false)

const closeMenus = () => {
  isMobileMenuOpen.value = false
  isAutomationsOpen.value = false
}

const closeAutomations = () => {
  isAutomationsOpen.value = false
}

const toggleAutomations = () => {
  isAutomationsOpen.value = !isAutomationsOpen.value
}

const automationsLinks = computed(() => [
  { href: '/automazioni-ai', text: 'Panoramica' },
  { href: '/automazioni-ai#chatbots', text: 'Chatbot AI' },
  { href: '/automazioni-ai#voice-agents', text: 'Agenti Vocali' },
  { href: '/automazioni-ai#process-automation', text: 'Automazione Processi' },
  { href: '/automazioni-ai#marketing-automation', text: 'Marketing AI' },
  { href: '/automazioni-ai#lead-generation', text: 'Lead Generation' }
])
</script>
